/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppTemplateUpdateParameterMapPathParams,
	WhatsAppTemplateUpdateParameterMapRequest,
	WhatsAppTemplateUpdateParameterMapResponse,
} from '../types/WhatsAppTemplateUpdateParameterMap'

/**
 * PATCH /organisations/:organisationId/whatsapp-templates/:templateId/parameter-map
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::updateParameterMap
 */
export async function whatsAppTemplateUpdateParameterMap(
	organisationId: WhatsAppTemplateUpdateParameterMapPathParams['organisationId'],
	templateId: WhatsAppTemplateUpdateParameterMapPathParams['templateId'],
	data: WhatsAppTemplateUpdateParameterMapRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppTemplateUpdateParameterMapResponse>> {
	return axiosInstance.patch(
		`/organisations/${organisationId}/whatsapp-templates/${templateId}/parameter-map`,
		data,
		config,
	)
}
